import { FormCreator, FormCreatorProps, FormFieldDef } from "@/components/shared/form-creator";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Service } from "@/models/services.model";
import { zodResolver } from "@hookform/resolvers/zod";
import { Dispatch, SetStateAction, useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

interface AddSubServiceModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onSubmit: (values: Partial<Service>) => Promise<void>;
}

const formSchema = z.object({
  name: z.string().min(1, "Name is required"),
  price: z.string().transform((val) => Number(val)),
  payment: z.string().transform((val) => Number(val)),
  priced_per_job: z.boolean(),
});

type FormValues = z.infer<typeof formSchema>;
type RawValues = z.input<typeof formSchema>;

export default function AddSubServiceModal({ open, setOpen, onSubmit }: AddSubServiceModalProps) {
  const [loading, setLoading] = useState(false);
  const form = useForm<RawValues, any, FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: "",
      priced_per_job: false,
    },
  });

  const fields: FormFieldDef[] = [
    { type: "text", name: "name", label: "Service Name", required: true },
    { type: "number", name: "price", label: "Service Price", required: true },
    { type: "number", name: "payment", label: "Individual Payment", required: true },
    {
      type: "switch",
      name: "priced_per_job",
      label: "Priced per job",
      description: "Finished work waits as a billing exception until you set the appointment's price.",
    },
  ];

  const props: FormCreatorProps = {
    form,
    onSubmit: async (values: FormValues) => {
      setLoading(true);
      try {
        await onSubmit(values);
        form.reset();
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    },
    formDefinition: fields,
    buttonText: loading ? "Creating..." : "Create Service",
    resetButtonText: "Reset",
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Add Service</DialogTitle>
        </DialogHeader>

        <FormCreator {...props} />
      </DialogContent>
    </Dialog>
  );
}
